import { render, staticRenderFns } from "./Settings.view.vue?vue&type=template&id=03212018&"
import script from "./Settings.view.vue?vue&type=script&lang=js&"
export * from "./Settings.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports